import { FiMail, FiPhone, FiBriefcase, FiMapPin } from "react-icons/fi";

export default function MyProfile() {
  return (
    <div className="space-y-8">
      {/* Header Card */}
      <div
        className="
          bg-white
          rounded-3xl
          border
          border-gray-100
          p-8
          shadow-sm
        "
      >
        <div className="flex items-center gap-6">
          <div
            className="
              h-24
              w-24
              rounded-3xl
              bg-primary-700
              text-white
              flex
              items-center
              justify-center
              text-3xl
              font-bold
            "
          >
            HR
          </div>

          <div>
            <h1 className="text-2xl font-bold text-gray-900">HR Admin</h1>

            <p className="text-gray-500">Human Resource Manager</p>

            <p className="text-sm text-primary-700 mt-2">Employee ID: EMP001</p>
          </div>
        </div>
      </div>

      {/* Information */}
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <ProfileCard title="Personal Information">
          <InfoRow icon={<FiMail />} label="Email" value="hr@charms.com" />

          <InfoRow icon={<FiPhone />} label="Phone" value="+91 9876543210" />

          <InfoRow
            icon={<FiMapPin />}
            label="Address"
            value="Ludhiana, Punjab"
          />
        </ProfileCard>

        <ProfileCard title="Employment Information">
          <InfoRow
            icon={<FiBriefcase />}
            label="Department"
            value="Human Resources"
          />

          <InfoRow
            icon={<FiBriefcase />}
            label="Designation"
            value="HR Manager"
          />

          <InfoRow
            icon={<FiBriefcase />}
            label="Joining Date"
            value="12 Jan 2024"
          />
        </ProfileCard>
      </div>

      {/* Bank */}
      <ProfileCard title="Bank Information">
        <div className="grid md:grid-cols-3 gap-5">
          <InfoBlock label="Bank Name" value="State Bank of India" />

          <InfoBlock label="Account Number" value="XXXX XXXX 2456" />

          <InfoBlock label="IFSC" value="SBIN0001234" />
        </div>
      </ProfileCard>
    </div>
  );
}

function ProfileCard({ title, children }) {
  return (
    <div
      className="
        bg-white
        rounded-3xl
        border
        border-gray-100
        p-6
        shadow-sm
      "
    >
      <h3 className="font-semibold text-lg text-gray-900 mb-6">{title}</h3>

      {children}
    </div>
  );
}

function InfoRow({ icon, label, value }) {
  return (
    <div className="flex items-center gap-4 mb-4">
      <div
        className="
          h-10
          w-10
          rounded-xl
          bg-primary-50
          text-primary-700
          flex
          items-center
          justify-center
        "
      >
        {icon}
      </div>

      <div>
        <p className="text-xs text-gray-500">{label}</p>

        <p className="font-medium text-gray-900">{value}</p>
      </div>
    </div>
  );
}

function InfoBlock({ label, value }) {
  return (
    <div>
      <p className="text-xs text-gray-500">{label}</p>

      <p className="font-semibold text-gray-900 mt-1">{value}</p>
    </div>
  );
}
